.listItemIcon {
  color: inherit;
}

/* Sidebar row metrics: 32px rows (44px on a coarse pointer), no row margins, 18px icons, one line.
   Scoped by the row marker so the Mixer/Tuner/Keyboard rows, built in other packages, match. */
.tools [data-list-row],
.tools .theoryTrigger {
  box-sizing: border-box;
  min-height: 32px;
  margin: 0;
  padding: 0 10px;
  gap: 10px;
  border-radius: var(--tuna-shape-radius-md);
  color: var(--tuna-content-secondary);
  white-space: nowrap;
}

.tools [data-list-row]:hover,
.tools .theoryTrigger:hover {
  color: var(--tuna-content-primary);
}

.tools [data-list-row]:focus-visible,
.tools .theoryTrigger:focus-visible {
  outline: 2px solid var(--tuna-focus-ring);
  outline-offset: -2px;
}

.tools [data-list-row] > :first-child:has(svg),
.tools .theoryTrigger > :first-child:has(svg) {
  padding-right: 0;
  color: var(--tuna-content-secondary);
}

.tools [data-list-row] svg,
.tools .theoryTrigger svg {
  width: 18px;
  height: 18px;
}

@media (pointer: coarse) {
  .tools [data-list-row],
  .tools .theoryTrigger {
    min-height: 44px;
  }
}

/* Active row: tinted background, primary icon, medium weight (aria-current carries it for AT). */
.tools .active {
  background-color: color-mix(in oklch, var(--tuna-palette-primary-main) 12%, transparent);
  color: var(--tuna-content-primary);
  font-weight: 550;
}

.tools .active > :first-child:has(svg) {
  color: var(--tuna-palette-primary-main);
}

.count {
  margin-left: auto;
  font-size: var(--tuna-typography-fontSize-xs);
  font-variant-numeric: tabular-nums;
  color: var(--tuna-content-secondary);
}

/* Theory rows hang off a 1px tree guide, without icons. */
.tools .tree {
  margin: 2px 0 4px 19px;
  padding-inline-start: 9px;
  border-left: 1px solid var(--tuna-palette-divider);
}

.subList {
  list-style: none;
  margin: 0;
  padding: 0;
}

/* Group sub-labels are plain text, not links: smaller, muted, no hover, no pointer. */
.subLabel {
  display: block;
  padding: 10px 10px 4px;
  font-size: var(--tuna-typography-fontSize-xs);
  font-weight: 500;
  color: var(--tuna-content-secondary);
  cursor: default;
  list-style: none;
}

.tools .theoryRow {
  min-height: 30px;
}

@media (pointer: coarse) {
  .tools .theoryRow {
    min-height: 44px;
  }
}

/* Collapsed rail: icon-only rows. Labels are visually hidden, not removed, so each row keeps its name. */
.rail [data-list-row] {
  justify-content: center;
  width: 40px;
  padding: 0;
  margin-inline: auto;
}

.rail [data-list-row] > :not(:first-child) {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
